import { StepButton, Value, Wrapper } from './Counter.styles';
import type { CounterProps } from './Counter.types';

export function Counter({
  value,
  min = 0,
  max,
  step = 1,
  onChange,
  decreaseLabel = 'Decrease',
  increaseLabel = 'Increase',
}: CounterProps) {
  const canDecrement = value - step >= min;
  const canIncrement = max === undefined || value + step <= max;

  return (
    <Wrapper>
      <StepButton
        type="button"
        aria-label={decreaseLabel}
        disabled={!canDecrement}
        onClick={() => onChange(value - step)}
      >
        −
      </StepButton>
      <Value aria-live="polite">{value}</Value>
      <StepButton
        type="button"
        aria-label={increaseLabel}
        disabled={!canIncrement}
        onClick={() => onChange(value + step)}
      >
        +
      </StepButton>
    </Wrapper>
  );
}
